import { useEffect } from 'react';
import { ProductDetailsHashSyncAction } from './useProductDetailsHashSync.utils';

interface UseProductDetailsFragmentMirrorParams {
  action: ProductDetailsHashSyncAction;
  openedItemValue?: string;
  onWriteFragment: (value?: string) => void;
  onDropFragment: () => void;
  onCloseModal: () => void;
}

const useProductDetailsFragmentMirror = ({
  action,
  openedItemValue,
  onWriteFragment,
  onDropFragment,
  onCloseModal,
}: UseProductDetailsFragmentMirrorParams) => {
  useEffect(() => {
    if (action === 'closeModal') {
      onCloseModal();
      return;
    }

    if (action === 'writeFragment') {
      onWriteFragment(openedItemValue);
      return;
    }

    if (action === 'dropFragment') {
      onDropFragment();
    }
  }, [action, openedItemValue, onWriteFragment, onDropFragment, onCloseModal]);
};

export default useProductDetailsFragmentMirror;
